export default "__VITE_ASSET__KqX9TBoa__"